import { useRef, useState } from 'react'
import { useTranslation } from 'next-i18next'
import styled from 'styled-components'
import { insert, without } from 'ramda'
import {
  Box,
  Button,
  ButtonIcon,
  Checkbox,
  IconClose
} from '@machobear/design-system'

import { Label } from '@/components/text'
import useOnClickOutside from '@/components/use-onclick-outside'

import { CheckboxSection, FilterWrapper } from '../elements'
import { handleDataLayerEvent } from '../utils'

const StyledFilterWrapper = styled(FilterWrapper)`
  width: fit-content;
  margin-top: 8px;
  ${props => props.isExt && 'right: 0;'}
`

const DealsFilter = ({
  deals = [],
  onChange,
  clickOutsideCallback,
  close,
  isExt
}) => {
  const { t } = useTranslation()
  const DealsFilterRef = useRef()
  useOnClickOutside(DealsFilterRef, e => clickOutsideCallback(e))
  const [values, setValues] = useState(deals)

  const handleDealsChange = e => {
    handleDataLayerEvent('deals')
    const id = e.target.id
    const checked = e.target.checked
    const filter = checked ? insert(0, id, values) : without([id], values)
    return setValues(filter)
  }

  const DEALS = [
    {
      id: 'special_offer',
      label: t('Special Offer')
    },
    {
      id: 'price_drop',
      label: t('Price Drop')
    }
  ]

  return (
    <div ref={DealsFilterRef}>
      <StyledFilterWrapper isExt={isExt}>
        <Box
          display="flex"
          flexDirection="column"
          padding="small"
          style={{ gap: '24px' }}
        >
          <Box display="flex" justifyContent="spaceBetween">
            <Label type="medium">
              {t('filters:b.listing_filter.edit.deals.label', 'Deals')}
            </Label>
            <ButtonIcon
              icon={<IconClose />}
              onClick={close}
              variant="transparent"
              tone="secondary"
            />
          </Box>
          <CheckboxSection>
            {DEALS.map(deal => (
              <Checkbox
                key={deal.id}
                onChange={handleDealsChange}
                checked={values.includes(deal.id)}
                id={deal.id}
                label={deal.label}
              />
            ))}
          </CheckboxSection>
        </Box>
        <Box
          display="flex"
          justifyContent="spaceBetween"
          padding="small"
          background="neutralSoft"
          borderTop="borderNeutralLight"
        >
          <Box style={{ maxWidth: 'fit-content' }}>
            <Button
              variant="transparent"
              size="small"
              onClick={() => {
                const withoutDealsFilters = values.filter(
                  val => val !== 'special_offer' && val !== 'price_drop'
                )
                setValues(withoutDealsFilters)
              }}
            >
              {t('Clear')}
            </Button>
          </Box>
          <Box style={{ maxWidth: 'fit-content' }}>
            <Button onClick={() => onChange({ deals: values })} size="small">
              {t('common.save', 'Save')}
            </Button>
          </Box>
        </Box>
      </StyledFilterWrapper>
    </div>
  )
}

export default DealsFilter
